module.exports = ['$scope', 'ngDroUAA', '$translate',
    'ngDroUtilsNotify', '$transitions', '$stateParams', '$filter', '$state', 'ngDroAnimateIt', '$interval',
    function ($scope, ngDroUAA, $translate,
            ngDroUtilsNotify, $transitions, $stateParams, $filter, $state, ngDroAnimateIt, $interval) {

        /*
         * Config
         */

        // Informazioni per la parametrizzazione della direttiva navabar-title.
        // $scope.infoTitle = {icon: 'fa-user fa-fw', message: 'jdro_person.modal.title'};

        //Oggetto per la traduzione del multiselect: translation="localLang"
        $scope.localLang = {
            selectAll: $translate.instant('jdro_common.multiSelect.selectAll'),
            selectNone: $translate.instant('jdro_common.multiSelect.selectNone'),
            reset: $translate.instant('jdro_common.multiSelect.reset'),
            search: $translate.instant('jdro_common.multiSelect.search'),
            nothingSelected: $translate.instant('jdro_common.multiSelect.nothingSelected')
        };

        // parametri per la richiesta canDo
        var params = {
            resource: "PERSON",
            privilege: $stateParams.id ? "UPDATE" : "CREATE"
        };

        /*
         * Init
         */
        $scope.person = {
            identity: {
                activated: false,
                hasPassword: false,
                roles: []
            },
            "companyDistrict": {
                "id": 1
            },
            groups: []
        };
        var backupPerson = {};

        $scope.groups = [];
        $scope.roles = [];
        $scope.companies = [];

        // conterrà i permessi
        $scope.jdroPerms = {};

        // Ottengo i permessi per le operazioni Update o Create   
        ngDroUAA.Profile.canDo(params.resource, params.privilege)
                .then(function (result) {
                    $scope.jdroPerms[params.privilege] = result.data;
                    if ($scope.jdroPerms[params.privilege] === true) {
                        initGroups();
                        initRoles();
                        initCompany();
                        initPerson();

                        // Setto un listener su transition start :
                        //      se ho cambiato qualche campo e non ho salvato faccio uscire un modal di conferma.
                        $scope.deregisterListener = $transitions.onStart({to: '*'}, catchStateTransition);
                        ngDroUtilsNotify.setDeregisterListner($scope.deregisterListener);
                    }
                })
                .catch(function (err) { });

        /*
         * Methods
         */

        //
        function initPerson() {
            if ($stateParams.id) {
                $scope.asyncFinish = 0;
                ngDroUAA.Person.findOne($stateParams.id).then(function (response) {
                    $scope.person = response.data;
                    /**
                     * Contollo se l'utente ha già settata la password.
                     */
                    if ($scope.person.identity) {
                        $scope.person.identity.hasPassword = true;
                    }

                    // Costruzione multi-select per i gruppi. Solo quando ho l'oggetto person
                    var groups = $scope.person.groups;
                    ngDroUAA.Group.findAll().then(function (data) {
                        angular.forEach($scope.groups, function (group) {
                            p = group;
                            found = $filter('filter')(groups, {id: group.id});
                            p.ticked = found && found.length > 0;
                        });
                        $scope.asyncFinish++;
                    });

                    // Costruzione multi-select per i ruoli. Solo quando ho l'oggetto person
                    var roles = $scope.person.identity ? $scope.person.identity.roles : undefined;
                    ngDroUAA.Role.findAll().then(function (data) {
                        angular.forEach($scope.roles, function (role) {
                            p = role;
                            found = $filter('filter')(roles, role.roleName);
                            p.ticked = found && found.length > 0;
                        });
                        $scope.asyncFinish++;
                    });


                });
                // Siccome ho due chiamate asincrone, setto il watchers solo quando sono entrambe finite
                var ref = $scope.$watch('asyncFinish', function (newValue, oldValue) {
                    if ($scope.asyncFinish === 2) {
                        var intervaL = $interval(function () {    // per permettere alla multiselect di aggiornare i ruoli
                            angular.copy($scope.person, backupPerson);
                            //setModificationsListener();
                        }, 500, 1);
                        angular.copy($scope.person, backupPerson);
                        ref();
                        delete $scope.asyncFinish;
                    }
                }, true);
            } else {
                angular.copy($scope.person, backupPerson);
                //setModificationsListener();
            }

        }

        // Costruzione multi-select per i gruppi.
        function initGroups() {
            ngDroUAA.Group.findAll().then(function (response) {
                angular.forEach(response.data, function (group) {
                    p = group;
                    $scope.groups.push(p);
                });
            });
        }

        // Costruzione multi-select per i ruoli.
        function initRoles() {
            ngDroUAA.Role.findAll().then(function (response) {
                angular.forEach(response.data, function (role) {
                    p = role;
                    $scope.roles.push(p);
                });
            });
        }

        // Costruzione select per le company.
        function initCompany() {
            ngDroUAA.Company.findAll().then(function (response) {
                $scope.companies = response;
            });
        }

        // mi serve nel template per disabilitare i campi 
        $scope.hasPerms = function () {
            return $stateParams.id ? $scope.jdroPerms.UPDATE : $scope.jdroPerms.CREATE;
        };

        // Validazione dell'username.
        $scope.validateUsername = (function () {
            return {
                test: function (value) {
                    try {
                        for (var i = 0, len = $scope.identities.length; (value.length > 0 && i < len); ++i) {
                            if ($scope.identities[i].identity.toUpperCase() === value.toUpperCase() && ($scope.identities[i].id !== person.identity.id)) {
                                return false;
                            }
                        }
                        return true;
                    } catch (ex) {
                        return true;
                    }
                }
            };
        })();

        /**
         * Questa funzione setta nello scope l'oggetto 
         * form presente nella finestra modale.
         * Questa funzione è chiamata da ng-init="setFormScope(this)".
         * @param {type} scope
         */
        $scope.setFormScope = function (scope) {
            this.formScope = scope;
        };

        $scope.submit = function (isValid, next) {
            $scope.submitted = true;

            /**
             * Oggetto userForm settato nel ng-init.
             * @type @this;@pro;formScope@pro;userForm
             */
            var userForm = this.formScope.userForm;

            if (!$scope.person.identity) {
                $scope.person.identity = {};
            }

            if ($scope.person.identity.activated) {

                $scope.errorRole = ($scope.person.identity.roles.length === 0) ? true : false;

                /**
                 * Controllo che sono stati specificati i ruoli.
                 */
                isValid = ($scope.person.identity.roles.length === 0) ? false : true;

                if ($scope.person.identity.hasPassword === false) { // VUOLE MODIFICARE LA PASSWORD
                    /**
                     * Controllo che le password inserite siano corrette.
                     */
                    if (userForm.repeatPassword.$invalid || userForm.password.$invalid) {
                        isValid = false;
                        return;
                    }
                } else {
                    /**
                     * Se l'utente non vuole cambiare la password, può anche essere errata la sua validazione.
                     */
                    if (userForm.repeatPassword.$invalid && $scope.person.identity.hasPassword) {
                        isValid = true;
                    }
                }

                /**
                 * Controllo che non si stia andando ad inserire una username già usata da un
                 * altro utente in tal caso viene bloccato il submit della form.
                 */
                if (userForm.identity.$invalid) {
                    isValid = false;
                }
            } else if (!$scope.person.identity.activated && !userForm.firstName.$invalid && !userForm.lastName.$invalid && !userForm.email.$invalid) {
                isValid = true;
            }

            if (isValid) {
                messageUser = $translate.instant('jdro_person.confirm_delete_this_user');
                if ($scope.person.firstName && $scope.person.lastName) {
                    messageUser = $scope.person.firstName.sformat($scope.person.lastName);
                }



                /**
                 * A seconda che l'oggetto possieda o meno l'id riesco a capire 
                 * se devo invocare nil metodo PUT per l'update o il metodo
                 * POST per l'inserimento della persona.
                 */
                if (!$scope.person.id) {

                    if (angular.isUndefined($scope.person.identity.password)) {

                        $scope.person.identity.password = "adj" + new Date().getTime();   // TODO
                    }

                    ngDroUAA.Person.save($scope.person)
                            .then(function () {
                                ngDroUtilsNotify.insertSuccess(messageUser);
                                $scope.redirect(next);
                            })
                            .catch(function (error) {
                                if (error.status === 409) {
                                    ngDroUtilsNotify.error(null, 'jdro_person.notify_409_error', null, error);
                                } else {
                                    ngDroUtilsNotify.insertError(messageUser);
                                }
                            })
                            .finally(function () {
                                $scope.notModifyPassword();
                            });
                } else {
                    ngDroUAA.Person.update($scope.person)
                            .then(function () {
                                ngDroUtilsNotify.updateSuccess(messageUser);
                                $scope.redirect(next);
                            })
                            .catch(function (error) {
                                if (error.status === 409) {
                                    ngDroUtilsNotify.error(null, 'jdro_person.notify_409_error', null, error);
                                } else {
                                    ngDroUtilsNotify.updateError(messageUser, error);
                                }
                            })
                            .finally(function () {
                                $scope.notModifyPassword();
                            });
                }
            }
        };

        /**
         * Chiusura della finestra modale.
         */
        $scope.cancel = function () {
            //$scope.redirect(); 
            $state.go('uaa-module-person-list');
        };

        // Disabilitazione/Abilitazione dell'Identity sulla Person.
        $scope.hasIdentity = function () {
            if ($("#createIdentity").is(":checked")) {
                $scope.person.identity.activated = true;
                ngDroAnimateIt('#identityDiv', 'fadeIn');
            } else {
                $scope.person.identity.activated = false;
            }
        };

        // ng-click per il fade-in delle input della password.
        $scope.modifyPassword = function () {
            $scope.person.identity.hasPassword = false;
            ngDroAnimateIt('#identityPassword', 'fadeIn');
        };

        // ng-click per il fade-in delle input della password.
        $scope.notModifyPassword = function () {
            $scope.person.identity.hasPassword = true;
        };

        // Redirect alla pagina della lista.      
        $scope.redirect = function (next) {
            ngDroUtilsNotify.unregisterListner();
            next = next ? next : "uaa-module-person-list";
            $state.go(next);
        };

        // per $transitions, cattura gestisce unsaved changes
        function catchStateTransition(transition) {
            if (JSON.stringify($scope.person) !== JSON.stringify(backupPerson)) { // vedo se è stato cambiato qualche campo

                var options = {
                    form: $scope.userForm,
                    next: transition.to().name,
                    name: $scope.person.firstName + ' ' + $scope.person.lastName,
                    success: $scope.submit,
                    dismiss: $scope.redirect,
                    perms: $scope.hasPerms
                };

                ngDroUtilsNotify.confirmUnsavedChanges(options);

                return false; // equivale al vecchio event.preventDefault();
            }
        }

    }
];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/person/personDetail/personDetailCtrl.js
// module id = 430
// module chunks = 0